import * as yup from 'yup';

import { Tags } from '@/entities/vfo/types';

export const validationSchema = yup.object({
  email: yup
    .string()
    .test(
      'emailExists',
      'emailExists',
      (value, context) =>
        !context.options.context?.members?.some(
          (member: { email: string }) => member.email === value,
        ),
    )
    .email('invalidEmail')
    .required('requiredEmail'),
  tag: yup.mixed<Tags>().required('requiredTag'),
  firstName: yup.string(),
  lastName: yup.string(),
});

export type InviteMemberFormData = yup.InferType<typeof validationSchema>;
